import { render, staticRenderFns } from "./age.vue?vue&type=template&id=6873dcf2&scoped=true"
import script from "./age.vue?vue&type=script&lang=js"
export * from "./age.vue?vue&type=script&lang=js"
import style0 from "./age.vue?vue&type=style&index=0&id=6873dcf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6873dcf2",
  null
  
)

export default component.exports